import React, { useState, useEffect } from 'react';
import State from "../State";
import RegistrationService  from "./RegistrationService";
import './Registration.css';
import TeamRegistrationForm from "./TeamRegistrationForm";
import RegistrationConfirm from "./RegistrationConfirm";
import ClipLoader from "react-spinners/ClipLoader";
import Modal from 'react-modal';

function TeamRegistration({jsonServer}) {

    const [state] = useState(new State(useState(0)));

    const service = new RegistrationService(jsonServer, state, true);

    useEffect(() => {
        service.fetchCompetition();
    }, []);

    if (state.response) {
        return (
            <div>
                <RegistrationConfirm jsonServer={jsonServer} service={service} state={state} />
            </div>
        );
    }

    if (!state.classes) {
        return 'Hämtar data...';
    }

    if (state.loading) {
        return (
            <div>
                <ClipLoader loading={state.loading} size={150} />
            </div>
        );
    }

    if (!state.competition.applicationOpened) {
        return (
            <div className="registerForm">
                <h1>Anmälan är ännu inte öppnad.</h1>
            </div>
        )
    }
    if (!state.competition.isOrdinaryRegistrationOpened && !state.competition.isLateRegistrationOpened) {
        return (
            <div className="registerForm">
                <h1>Anmälan online är stängd.</h1>
            </div>
        )
    }

    const errorPopup = () => {
        const customStyles = {
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
            },
        };
        return (
            <Modal isOpen={state.showErrorPopup} contentLabel="Fel" style={customStyles}>
                {state.errorMsg}<br/>
                <button className="rightContent" onClick={() => {state.setShowErrorPopup(false)}}>Stäng</button>
            </Modal>
        );

    }

    const confirmPopup = () => {
        const customStyles = {
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
            },
        };
        return (
            <Modal isOpen={state.confirmMsg} contentLabel="Fel" style={customStyles}>
                Du kommer nu anmäla följande lag:<br/>
                { state.team }<br/>

                {state.applications.map((a, i) => {
                    const selectedClass = state.classes.filter(c => c.id === a.competitionClass)[0];
                    if (!selectedClass)
                        return null;
                    return (
                        <div>
                            Person {i + 1}<br/>
                            ----------------------------<br/>
                            Namn: {a.firstName} {a.lastName}<br/>
                            Förening/ort: {a.club}<br/>
                            Födelseår: {a.birthyear}<br/>
                            Kön: {a.gender === 'male' ? 'Man' : 'Kvinna'}<br/>
                            Land: {a.countryObject.label}<br/>
                            Klass: {selectedClass.name}<br/>
                            Busstransport: {a.bus ? 'Ja' : 'Nej'}<br/>
                            {a.noPhoto ? (<>Ej på bild<br/></>) : ''}
                            ======================<br/>
                        </div>
                    )
                })}
                <br/>
                <b>Totalt att betala: {state.totalFee} kr</b>
                <br/><br/>
                <div className="rightContent">
                    <button onClick={() => {
                        service.confirmed(true)
                    }}>OK
                    </button>
                    &nbsp;
                    <button onClick={() => {
                        service.confirmed(false)
                    }}>Avbryt
                    </button>
                </div>
            </Modal>
        );

    }

    const registration = state.applications[0];
    return (
        <>
            {errorPopup()}
            {confirmPopup()}
            <div className="registerForm">
                <h1>{state.competition.isOrdinaryRegistrationOpened ? 'Anmälan' : 'Efteranmälan'} Lag</h1>
                <span className="errorMessage">{state.errorMsg}</span>

                <input className="clubInput" type="text" name="team" placeholder="Lagnamn"
                       size={31}
                       value={state.team} onChange={(e) => {
                    service.handleStateChange(-1, 'team', e.target.value)
                }} onKeyUp={(e) => {
                    service.handleKeyPress(e)
                }}/>

                <table className="classChoiceTable">
                    <thead>
                    <tr key="header1" className="no_bottomline">
                        <th>Klass</th>
                        <th colSpan="3">Pris per löpare (SEK)</th>
                    </tr>
                    <tr key="header2">
                        <th></th>
                        <th width="50"></th>
                        <th>Vuxen</th>
                        <th className="price" width="55">Ungd.</th>
                    </tr>
                    </thead>
                    <tbody>
                    {state.classes.map((c, classIndex) => {
                        if (service.isCompetitionClass(c.id)) {
                            return null;
                        }
                        return (
                            <tr key={c.id}
                                className={classIndex + 0 < state.classes.length ? '' : 'no_bottomline'}>
                                <td>
                                    <input type="radio"
                                           id={c.id}
                                           name={'competitionClass'}
                                           value={c.id}
                                           checked={registration.competitionClass === c.id}
                                           onChange={(e) => {
                                               service.handleStateChange(0, 'competitionClass', e.target.value)
                                           }} onKeyUp={(e) => {
                                        service.handleKeyPress(e)
                                    }}/> <label
                                    htmlFor={c.id}>{c.name}{c.name !== c.description ? ', ' + c.description : ''}</label>
                                </td>
                                <th></th>
                                <td className="price">{Math.round(0.8 * (state.competition.isLate ? c.adultLatePrice : c.adultPrice))}</td>
                                <td className="price">{Math.round(0.8 * (state.competition.isLate ? c.youthLatePrice : c.youthPrice))}</td>
                            </tr>
                        )})}
                    </tbody>
                </table>


                {state.applications.map((registration, i) => (


                    <div key={'runner' + i} style={{display: "block"}}>
                        <TeamRegistrationForm service={service} state={state} index={i}/>
                    </div>

                ))}
                <p><label className="consenttext" htmlFor="consent">
                    <input type="checkbox" name="consent" id="consent" value={state.consent} onChange={(e) => {
                        service.handleStateChange(-1, 'consent', e.target.checked)
                    }}
                           onKeyUp={(e) => {
                               service.handleKeyPress(e)
                           }}/>&nbsp;
                    Jag godkänner att personuppgifterna används för att administrera
                    tävlingen och för publicering av start- och resultatlista.</label>
                </p>
                <br/>
                <span className="totalFee">Att betala:</span>
                <span className="rightContent totalFee">
                    {state.totalFee} SEK &nbsp;
                </span>
                <br/>
                <div className="rightContent">
                    <button type="button" name="saveApplication" onClick={(e) => {
                        service.onSaveForm()
                    }}>Anmäl
                    </button>

                </div>
            </div>
            <br/>
            <br/>
            *Ort eller förening som ej är ansluten till Svenska Friidrottsförbundet.<br/>
            **Kryssa om du ej önskar att vara med på bild på Kanallöpets hemsida.
        </>
    );
}

export default TeamRegistration;